import React from 'react';
import { useParams } from 'react-router-dom';
import { Container, Grid } from '@tq/ui-components';

import { useConsultation } from 'api';
import { ArchivedPastResponseCard, ResponseHeader } from './components';
import { useResponse } from './hooks';

export const ArchivedResponse: React.FC = () => {
  const { id, responseId } = useParams();
  const consultationId = +(id ?? 0);
  const { data: consultation } = useConsultation(consultationId);
  const { pastResponses } = useResponse(consultationId);

  const response = pastResponses.find((r) => r.id === +(responseId ?? 0));

  return (
    <Container px={{ base: 0, lg: 4, xl: 0 }}>
      <Grid gridGap={4} mb={12}>
        <ResponseHeader consultation={consultation} />
        <ArchivedPastResponseCard response={response} consultation={consultation} />
      </Grid>
    </Container>
  );
};
